<style>
.van-tabs--line .van-tabs__wrap{height: 88px}
.van-tabs__wrap--scrollable .van-tab{margin:0px 10px}
.van-tabs__content--animated{background: linear-gradient( 153deg, #EBF3FD 0%, #F4F8FC 100%);box-shadow: 0px 0px 4px 1px rgba(10,63,190,0.16);border-radius: 3px;border: 1px solid #FFFFFF;}
</style>
<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="banner-box">
      <div class="banner-con">
        <div class="banner-title">轻骑兵<div style="font-size: 13px;vertical-align: super;line-height: 27px">®</div>工作流平台</div>
        <div class="banner-desc">流程聚合，管理有方</div>
        <div style="text-align: center">
          <img class="banner-img" src="../assets/img/unifiedProcessPhone/banner-img.png" />
        </div>
        <div class="app-button-div">
          <img class="app-button-img" src="../assets/img/zeroCodePhone/app-button-bg.png" @click="handleOpenPractice"/>
        </div>
        <!--工作流平台-->
        <div class="div-title">工作流平台</div>
        <div class="div-desc">工作流高效管理搭建工具</div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">快速实现流程建模</div>
            <div class="base-content-desc">采用可视化拖拽的方式进行流程开发，能够快速实现流程建模。</div>
          </div>
          <div>
            <img src="../assets/img/unifiedProcessPhone/two-flex1.png"/>
          </div>
        </div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">流程分析辅助企业决策</div>
            <div class="base-content-desc">对流程数据进行全方位的流程运行分析，通过不同的分析指标、统计维度以及展示形态，全面展现流程的执行情况，为管理者提供决策依据和流程优化支持。</div>
          </div>
          <div>
            <img src="../assets/img/unifiedProcessPhone/two-flex2.png" style="margin-top: 40px"/>
          </div>
        </div>
        <div class="base-content-div">
          <div>
            <div class="base-content-title">快速响应用户需求</div>
            <div class="base-content-desc">提供丰富的流程审批场景，支持中国式流程审批操作，快速响应用户需求。</div>
          </div>
          <div>
            <img src="../assets/img/unifiedProcessPhone/two-flex3.png" style="margin-top: 15px"/>
          </div>
        </div>
        <div class="base-content-div" style="margin-bottom: 30px">
          <div>
            <div class="base-content-title">推动企业流程规范化</div>
            <div class="base-content-desc">提供可视化建模、自动化执行、数据分析、管理和监控等功能，有效地推动企业流程规范化。</div>
          </div>
          <div>
            <img src="../assets/img/unifiedProcessPhone/two-flex4.png" style="margin-top: 15px"/>
          </div>
        </div>
        <!-- 工作流平台 让您的流程化繁为简-->
        <div class="digitalize-div">
          <div class="div-title">工作流平台 让您的流程化繁为简</div>
          <div class="div-desc">让流程审批智能高效</div>
          <div class="digitalize">
            <div class="digitalize-bg">
              <img src="../assets/img/unifiedProcessPhone/digitalize.png" />
            </div>
          </div>
        </div>
        <!-- 主要功能 -->
        <div class="main-method">
          <div class="div-title">主要功能</div>
          <van-tabs
            v-model="mainActive"
            animated
            swipeable
            duration="0.5"
            line-width="80px"
            line-height="2px"
            title-active-color="#186CF5"
            color="#186CF5"
            style="z-index: 5"
          >
            <van-tab name="first">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px" src="../assets/img/unifiedProcessPhone/tab1.png"></div>
                可视化建模
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/unifiedProcess/function-box-img1.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>提供可视化的流程建模工具，支持采用拖拉拽的方式进行流程建模。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="second">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px;margin-bottom: 9px" src="../assets/img/unifiedProcessPhone/tab2.png"></div>
                流程测试
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/unifiedProcess/function-box-img2.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>支持参数配置、自动执行以及流程测试结果分析，减少流程调试时间，降低试错成本。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="third">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px;margin-bottom: 5px" src="../assets/img/unifiedProcessPhone/tab3.png"></div>
                流程执行
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/unifiedProcess/function-box-img3.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>提供丰富的流程审批场景，支持中国式流程审批操作。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="fourth">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px;margin-bottom: 2px" src="../assets/img/unifiedProcessPhone/tab4.png"></div>
                在线调整
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/unifiedProcess/function-box-img4.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>业务人员在线加签、加减节点，运维人员修改参与者、表单权限、流程配置等操作。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="fifth">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px;margin-bottom: 4px" src="../assets/img/unifiedProcessPhone/tab5.png"></div>
                流程运维
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/unifiedProcess/function-box-img5.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>提供流程基础运维服务，实现核心流程运维能力，同时支持对异常流程数据进行干预操作，如挂起、重启等。</div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab name="sixth">
              <div slot="title" style="line-height: 15px;color: #2e2e2e;text-align: center">
                <div><img style="width: 50px;margin-bottom: 4px" src="../assets/img/unifiedProcessPhone/tab6.png"></div>
                流程分析
              </div>
              <div class="main-tabs-tabItem">
                <img src="../assets/img/unifiedProcess/function-box-img6.png" />
              </div>
              <div class="main-tabs-tabItem-box">
                <div class="main-tabs-tabItem-context">
                  <div class="main-tabs-tabItem-context-item">
                    <div>支持对流程数据进行全方位的流程运行分析，全面展现流程的执行情况，为管理者提供决策依据和流程优化支持。</div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
        <!-- 满足多样化流程需求 -->
        <div class="div-title" style="position: relative;top: -10px">满足多样化流程需求</div>
        <div class="core-value">
          <div class="core-layout">
            <div class="core-content">
              <div class="core-item">
                <div>
                  <span class="value-title">对多个业务系统的流程进行统筹管理</span>
                  <div class="value-desc">当涉及多个业务差异性较大、无数据交互的系统时，用户可选择独立部署工作流平台。平台配备多租户管理功能，可对多个业务系统的流程进行统筹管理，同时确保各系统的流程数据相互隔离，互不影响。</div>
                  <img src="../assets/img/unifiedProcessPhone/core-item-1.png" />
                </div>
              </div>
              <div class="core-item" style="height: 150px">
                <div>
                  <span class="value-title">快速与第三方系统进行集成</span>
                  <div class="value-desc">当用户自己开发的第三方业务系统涉及流程引擎开发需求时，工作流平台可快速实现与第三方系统的集成，为其提供流程相关能力支撑。</div>
                  <img src="../assets/img/unifiedProcessPhone/core-item-2.png" />
                </div>
              </div>
              <div class="core-item" style="height: 150px">
                <div>
                  <span class="value-title">为用户提供流程相关的能力支撑</span>
                  <div class="value-desc">涉及到开发、管理、运维、监控、分析等流程相关需求时，流程平台可为用户提供统一、标准化、自动化的的流程业务做支撑。</div>
                  <img src="../assets/img/unifiedProcessPhone/core-item-3.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部公司信息 -->
        <CompanyInformation
          @changePracticeMenuShow="handleOpenPractice"
        ></CompanyInformation>
      </div>
      <!-- 右侧菜单 -->
      <RightMenu
        :isMenuShow="isMenuShow"
        @rightMenuShow="handleRightMenuShow"
      ></RightMenu>
      <!-- 底部立即体验弹出 -->
      <ExperienceNow
        :isPopShow="isPopShow"
        @CloseExperienceNow="handleCloseExperienceNow"
      ></ExperienceNow>
    </div>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import Swiper, { Navigation } from "swiper";
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import CompanyInformation from "./include/CompanyInformation";
import ExperienceNow from "./include/ExperienceNow";
const function21 = require("../assets/img/homePage/function21.gif");
const function22 = require("../assets/img/homePage/function22.gif");
Swiper.use([Navigation]);
export default {
  name: "ZeroCodePhone",
  components: {
    PhoneFooter,
    PhoneHeader,
    CompanyInformation,
    RightMenu,
    ExperienceNow,
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
      videoPlayDialogVisible: false, // 顶部视频播放弹窗
      modelActive: "formular", // tab页默认显示
      mainActive: "first", // tab页默认显示
      funcSrc: "function21", // 动图播放完毕后显示gif
    };
  },
  watch: {
    mainActive(n) {
      if (n === "second") {
        this.funcSrc = function21;
        setTimeout(() => {
          this.funcSrc = function22;
        }, 3000);
      }
    },
  },
  methods: {
    // 了解更多
    handleRouter() {
      this.$router.push("/CasePhonePage");
    },
    // 打开右侧菜单弹窗
    handleMenu() {
      this.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      this.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      this.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      this.isPopShow = false;
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* 头部 */
.banner-box {width: 100%;height: 391px;background: url("../assets/img/unifiedProcessPhone/banner-bg.png") no-repeat;background-size: 100%;margin-top: 52px;}
.banner-con {width: 100%;margin: 0 auto;padding-top: 20px;}
.banner-title {font-size: 23px;font-weight: bold;line-height: 50px;text-align: center;display: flex;justify-content: center;}
.banner-desc {display: flex;align-items: center;position: relative;font-size: 16px;font-weight: 400;justify-content: center;}
.banner-img{width: 80%}
.app-button-div{width: 100%;text-align: center;margin-top: -10px}
.app-button-img{width: 120px;}

.div-title {font-size: 22px;font-weight: bold;line-height: 50px;text-align: center;display: flex;justify-content: center;color: #2e2e2e;margin-top: 50px}
.div-desc {display: flex;align-items: center;position: relative;font-size: 14px;font-weight: 400;justify-content: center;color: #8E8E8E;margin-bottom: 30px}

.base-content-div{width: 92%;margin: 15px auto;box-shadow: 0px 0px 10px 1px rgba(0,46,154,0.15);border-radius: 5px 5px 5px 5px;display: flex}
.base-content-title{font-weight: bold;font-size: 16px;color: #014BE6;line-height: 31px; margin: 10px 0px 5px 15px;}
.base-content-desc{font-size: 13px;color: #2E2E2E;line-height: 22px;width: 210px; margin: 0px 0px 10px 15px;text-align: justify}
.base-content-div img{width: 125px;margin-top: 10px}

/* 企业数字化转型的底座 */
.digitalize-div{background: url("../assets/img/unifiedProcessPhone/digitalize-bg.png") no-repeat;background-size: 100% 100%;padding-top: 1px;padding-bottom: 20px}
.digitalize {width: 100%;}
.digitalize > img {width: 100%;margin-top: 20px;}
.digitalize-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding-top: 50px;padding-bottom: 25px;}
.digitalize-bg {text-align: center;padding: 0 18px;}
.digitalize-bg > img {width: 100%;margin-bottom: 10px;}

/* 主要功能 */
.main-method {overflow: hidden;}
.main-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding: 44px 0 24px 0;}
.main-tabs-tabItem {display: flex;margin: 20px 0 25px 0;justify-content: center;}
.main-tabs-tabItem > img {height: 200px;}
.main-tabs-tabItem-box {display: flex;justify-content: center;height: 100%;min-height: 100px;}
.main-tabs-tabItem-box > div {width: 90%;}
.main-tabs-tabItem-context-item {display: flex;margin-bottom: 15px;}
.main-tabs-tabItem-context-item > img {height: 20px;padding-right: 10px;}
.main-tabs-tabItem-context-item > div {font-size: 15px;line-height: 25px;}

/* 快速构建轻应用 */
.core-value {background: #FFFFFF;}
.core-title {font-size: 25px;font-weight: bold;line-height: 30px;text-align: center;padding: 40px 0 30px 0;}
.core-layout {display: flex;padding-bottom: 30px;}
.core-content {width: 90%;margin: auto;color: #FFFFFF;}
.value-title {font-size: 16px;font-weight: bold;}
.value-desc {font-size: 13px;margin-top: 15px;line-height: 25px;color: #EEEEEE;}
.core-item {text-align:justify;background: #3273F3;height: 175px;background-size: 100% 80px;margin-bottom: 20px;display: flex;padding: 20px 20px;border-radius: 3px;}
.core-item img{width: 150px;position: relative;left: 190px;top: -100px;}

/* 案例 */
.case {background: url("../assets/img/phoneHomePage/case-bg.png");height: 828px;}
.case-title {font-size: 25px;font-weight: bold;line-height: 56px;text-align: center;padding: 30px 0;color: white;}
.case-box {display: flex;justify-content: center;}
.case-swipe {height: 350px;}
.case-swipe >>> .van-swipe__indicators .van-swipe__indicator {background: #333333;}
.case-swipe >>> .van-swipe__indicator--active {background-color: #1989fa !important;}
.case-item {height: 100%;width: 90%;padding: 20px 20px 0 20px;background-image: linear-gradient(to bottom, #fff, #e9f0ff);border-radius: 5px;}
.van-swipe-item {display: flex;justify-content: center;}
.case-item > img {height: 55px;}
.case-item > .title {margin: 10px 0;font-size: 18px;font-weight: 600;}
.case-item > .text {font-size: 15px;font-weight: 400;line-height: 25px;}
.case-application-box {display: flex;justify-content: center;}
.case-application {width: 90%;height: 200px;padding: 20px;background: #203558;margin-top: 40px;}
.case-application .title {color: #fff;font-size: 18px;font-weight: bold;}
.case-application-items {display: flex;justify-content: space-between;}
.case-application-item > div {font-size: 15px;color: #fff;margin-bottom: 15px;}
.case > .btn {display: flex;justify-content: center;margin-top: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/UnifiedProcessPhone.vue